

export default function GridPropIdFormatter(index, colnum) {

    return "table-grid-row-" + index + "-col-" + colnum;
}

